/* eslint-disable local/no-hardcoded-hex -- brand logo SVG; fixed brand colors are not subject to theme switching */
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

const CtxpLogoMark = ({ ...props }: IconProps) => (
  <svg
    height='32'
    viewBox='0 0 32 32'
    width='32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    aria-label='Choose Texas Power logo'
    {...props}
  >
    <title>Choose Texas Power logo</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.11151 32L17.5102 19.7369L12.9919 16.3807L19.6804 11.2424L16 0L12.0576 11.9497L0 12.2229L9.88854 19.7771L6.11151 32Z'
      fill='#2D3E50'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 24.4458L25.8885 32L22.1115 19.777L32 12.2229L21.126 11.999L17.5102 16.3807L22.1115 19.777L16 24.4458Z'
      fill='#E94F53'
    />
  </svg>
)

export default CtxpLogoMark
